/**
 * Distinguir visor iframe (Looker) vs dashboard nativo del Creador.
 */

/** URL interna de un reporte del constructor. Nunca debe usarse como src de iframe. */
export function customReportMarker(reportId) {
    return reportId ? `custom:${reportId}` : 'custom-report-view';
}

/** true si el reporte se pinta con CustomReportRenderer, no iframe. */
export function isCustomBuiltReport(report) {
    if (!report) return false;
    if (report.isCustom) return true;
    if (report.customConfig) return true;
    const url = String(report.dashboardUrl || '').trim();
    return url === 'custom-report-view' || url.startsWith('custom:');
}

/** true si la URL es un embed externo (no la propia app). */
export function isExternalEmbedUrl(url) {
    if (!url || typeof url !== 'string') return false;
    const trimmed = url.trim();
    if (!/^https?:\/\//i.test(trimmed)) return false;
    try {
        const parsed = new URL(trimmed);
        if (typeof window !== 'undefined' && parsed.origin === window.location.origin) return false;
        if (/reportes\.centralmedia\.mx$/i.test(parsed.hostname)) return false;
        return true;
    } catch (e) {
        return false;
    }
}

/** Orígenes de la app del estudio Médico Digital (abre con pase SSO, ver backend/sso_estudio.js). */
const ORIGENES_ESTUDIO = (process.env.REACT_APP_ESTUDIO_ORIGENES || 'https://cm-md-26.web.app,https://cm-md-26.firebaseapp.com')
    .split(',')
    .map((o) => o.trim().replace(/\/+$/, ''))
    .filter(Boolean);

/** true si la URL es la app del estudio Médico Digital. */
export function isEstudioUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
        return ORIGENES_ESTUDIO.includes(new URL(url.trim()).origin);
    } catch (e) {
        return false;
    }
}

/** true si el reporte se pinta con el testigo PDF en vez del dashboard. */
export function shouldUseTestigoPdf(report) {
    return Boolean(report?.testigoPdfAsViewer && report?.testigoPdf?.url);
}

/** Looker / Data Studio u otro embed externo. Nunca la app misma ni un marcador del constructor. */
export function shouldUseIframe(report) {
    if (shouldUseTestigoPdf(report)) return false;
    if (isCustomBuiltReport(report)) return false;
    return isExternalEmbedUrl(report?.dashboardUrl);
}

/** Coincide permiso con reporte por id o dashboardUrl (sin mezclar marcadores custom). */
export function permissionMatchesReport(permission, report) {
    if (!permission || !report) return false;
    if (permission.reporteId && permission.reporteId === report.id) return true;
    if (permission.dashboardUrl && report.dashboardUrl && permission.dashboardUrl === report.dashboardUrl) {
        const url = String(report.dashboardUrl);
        if (url === 'custom-report-view' || url.startsWith('custom:')) {
            return permission.reporteId === report.id;
        }
        return true;
    }
    return false;
}
